import script from "./ProjectSmetaActual.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectSmetaActual.vue?vue&type=script&setup=true&lang=js"

import "./ProjectSmetaActual.vue?vue&type=style&index=0&id=374fa1a9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374fa1a9"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QLinearProgress,QTr,QTh,QTd,QInnerLoading});
